module.exports = __webpack_public_path__ + "img/share.2557f05e.svg";